module.exports = __webpack_public_path__ + "static/flags/IE-3a18fa7c0aaeebb5dfa7d68dc55d0f4d.gif";